import { LoadingButton } from '@mui/lab';
import {
    Avatar,
    Box,
    Grid,
    IconButton,
    Paper,
    Tab,
    Tabs,
    Typography,
    useTheme,
} from '@mui/material';
import { useSnackbar } from 'notistack';
import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import SwipeableViews from 'react-swipeable-views';
import {
    useCreateListDataMutation,
    useGetDataQuery,
    useGetListDataQuery,
} from '../../api/apiSlice';
import ItemTabDevotion from '../../components/fragments/ItemTabDevotion';
import ListEmpty from '../../components/fragments/ListEmpty';
import Screen from '../../components/fragments/Screen';
import errorSnackbar from '../../utils/errorSnackbar';
import { MessageOutlined, ShareOutlined } from '@mui/icons-material';
import { shareMinister } from '../../utils/sharePost';
import useAuth from '../../hooks/useAuth';

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && <Box p={1}>{children}</Box>}
        </div>
    );
}

export default function ScreenMinisterView() {
    const [value, setValue] = useState(0);

    const { id: username } = useParams();
    const { enqueueSnackbar } = useSnackbar();
    const theme = useTheme();
    const navigate = useNavigate();
    const { isLoggedIn } = useAuth();

    const {
        data: ministerRes,
        isFetching,
        refetch: refetchPastor,
    } = useGetDataQuery(
        { list: `/pastor/${username}` },
        { refetchOnMountOrArgChange: true }
    );

    const [toggleFollow, { isLoading: isFollowLoading }] =
        useCreateListDataMutation();

    const {
        links: { avatar } = {},
        about,
        firstName,
        surname,
        cover,
        analytics: { follows, devotions, following } = {},
    } = ministerRes?.data || {};

    const name = `${firstName} ${surname}`;

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleChangeIndex = (index) => {
        setValue(index);
    };

    const { data: { data: devotionList = [] } = {} } = useGetListDataQuery({
        list: `/pastor/${username}/devotions`,
    });

    if (!ministerRes?.data)
        return <Screen authPass title={'Minister'} loading={isFetching} />;

    return (
        <Screen loading={isFetching} title={'Minister'} authPass disablePadding>
            <Box
                sx={{
                    height: (window.innerWidth * 312) / 820,
                    width: '100%',
                    backgroundColor: 'rgba(0,0,0,0.2)',
                    backgroundImage: `url("${cover || avatar}")`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundBlendMode: 'soft-light',
                }}
            ></Box>
            <Box
                sx={{
                    width: window.innerWidth - 32,
                    position: 'absolute',
                    top: window.innerWidth * 0.2695 + 56,
                    left: 16,
                }}
                className="d-flex justify-content-between"
            >
                <Avatar
                    sx={{
                        width: 80,
                        height: 80,
                        border: `3px solid ${theme.palette.background.default}`,
                    }}
                    src={avatar}
                >
                    {`${name?.slice(0, 2)}`}
                </Avatar>
                <Box className="d-flex align-items-end">
                    <IconButton
                        sx={{ mr: 1 }}
                        size="small"
                        color="primary"
                        onClick={() =>
                            shareMinister(username, `${firstName} ${surname}`)
                        }
                    >
                        <ShareOutlined />
                    </IconButton>
                    {isLoggedIn && (
                        <IconButton
                            sx={{ mr: 1 }}
                            size="small"
                            color="primary"
                            onClick={() => navigate(`/chat/${username}`)}
                        >
                            <MessageOutlined />
                        </IconButton>
                    )}
                    <LoadingButton
                        // size="small"
                        loading={isFollowLoading}
                        // color="inherit"
                        variant={following ? 'outlined' : 'contained'}
                        onClick={async () => {
                            const { data, error } = await toggleFollow({
                                list: `/pastor/${username}/toggle_follow`,
                                body: {},
                            });

                            errorSnackbar(error, enqueueSnackbar);

                            if (data) {
                                enqueueSnackbar(`${data?.message}`);
                                refetchPastor();
                            }
                        }}
                    >
                        {following ? 'Following' : 'Follow'}
                    </LoadingButton>
                </Box>
            </Box>
            <Grid item sx={{ mt: 6, mx: 2 }} xs={12}>
                <Paper sx={{ background: 'none', boxShadow: 'none', mb: 2 }}>
                    <Typography variant="h6">{`${name}`}</Typography>
                    <Typography color="text.secondary" variant="body2">
                        @{username}
                    </Typography>
                    <Typography sx={{ mt: 1 }}>
                        <span className="fw-bold">{follows}</span> Followers
                    </Typography>
                </Paper>
            </Grid>

            <Grid item xs={12}>
                <Tabs
                    value={value}
                    onChange={handleChange}
                    variant="fullWidth"
                    textColor={
                        theme.palette.mode == 'light' ? 'primary' : 'inherit'
                    }
                >
                    <Tab label="About" />
                    <Tab label={`Devotions (${devotions})`} />
                </Tabs>

                <SwipeableViews
                    index={value}
                    onChangeIndex={handleChangeIndex}
                    sx={{ mt: 0, pt: 0 }}
                >
                    <TabPanel value={value} index={0}>
                        <Box sx={{ mx: 0.5 }}>
                            {about ? (
                                <div
                                    className="my-3"
                                    dangerouslySetInnerHTML={{ __html: about }}
                                ></div>
                            ) : (
                                <Typography className="text-justify my-3">
                                    Follow <b>{name}</b> on myKanisa to interact
                                    with their activity.
                                </Typography>
                            )}
                        </Box>
                    </TabPanel>
                    <TabPanel value={value} index={1}>
                        {devotionList?.length < 1 && (
                            <ListEmpty title={`No devotions from "${name}"`} />
                        )}
                        {devotionList?.map((data) => (
                            <ItemTabDevotion key={data?.id} devotion={data} />
                        ))}
                    </TabPanel>
                </SwipeableViews>
            </Grid>
        </Screen>
    );
}
